<input id="input-file" (change)="attachFile($event)" type="file" #fileUploadButton />
<input
  id="input-file-image"
  (change)="attachFileImage($event)"
  type="file"
  accept="image/*"
  #fileUploadImageButton
/>
